import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {reduxForm, Field, Form} from 'redux-form';
import {compose} from 'recompose';

import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import {withStyles} from '@material-ui/core/styles/index';

import {signInUser} from '../actions/usuario';
import {isAuthenticated} from '../helpers/auth.helper';

const styles = {
    action: {
        textAlign: 'center',
        marginTop: '15px'
    },
    group: {
        position: 'relative',
        marginBottom: '45px'
    },
    cardLogin:  {
        padding: '30px',
        paddingTop: '60px',
    },
    loginForm: {
        width: '420px',
        margin: '0 auto',
        zIndex: '99',
        display: 'block',
        marginTop: '5%',
        textAlign: 'center'
    }
};

const renderTextField = ({input, meta: {touched, error, invalid}, ...custom}) => {
    return (touched && invalid)
        ? <TextField error={invalid} helperText={error} {...input} {...custom} />
        : <TextField {...input} {...custom} />;
};

class LoginForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            submited: false,
            snackbarOpen: false,
            snackbarMessage: null
        };

        if (isAuthenticated()) {
            this.props.history.push('/dashboard');
        }
    }

    handleSubmit() {
        let form = this.props.signInForm;

        this.setState({submited: true});
        this.props.signIn(form.values.username, form.values.password);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.login && nextProps.login.error) {
            this.setState({snackbarMessage: <span id="message-id">{nextProps.login.error}</span>});
            this.setState({snackbarOpen: true});
            this.setState({submited: false});
        }

        if (this.props.login !== nextProps.login && nextProps.login.error == null) {
            this.props.history.push("/dashboard");
        }
    }

    render() {
        return (
            <Fragment>
                <div className="background"/>
                <div className="background2"/>

                <div className={this.props.classes.loginForm}>
                    <Form onSubmit={this.props.handleSubmit(this.handleSubmit.bind(this))}>
                        <Card>
                            <div className={this.props.classes.cardLogin}>
                                <div className={this.props.classes.group}>
                                    <Field type="text" name="username" label="Usuário" component={renderTextField} fullWidth={true}
                                           disabled={this.state.submited}/>
                                </div>
                                <div className={this.props.classes.group}>
                                    <Field type="password" name="password" label="Senha" component={renderTextField} fullWidth={true}
                                           disabled={this.state.submited}/>
                                </div>
                                <div className={this.props.classes.action}>
                                    <Button variant="raised" color="primary" type="submit" disabled={this.state.submited}>Entrar</Button>
                                </div>
                            </div>
                        </Card>
                    </Form>

                    <Snackbar autoHideDuration={5000} open={this.state.snackbarOpen} message={this.state.snackbarMessage}
                              onClose={() => this.setState({snackbarOpen: false})}/>
                </div>
            </Fragment>
        );
    }
}

const validate = values => {
    const errors = {};
    const requiredFields = ['username', 'password'];

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Obrigatório';
        }
    });

    if (values.username && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.username)) {
        errors.username = 'Usuário deve ser um email válido';
    }

    return errors;
};

const mapStateToProps = (state) => {
    return {
        signInForm: state.form.signInForm,
        login: state.usuarios
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        signIn: (login, senha) => dispatch(signInUser(login, senha))
    };
};

export default compose(
    withStyles(styles, {name: 'LoginForm'}),
    connect(mapStateToProps, mapDispatchToProps),
    reduxForm({form: 'signInForm', validate}),
)(LoginForm);


// WEBPACK FOOTER //
// src/components/LoginForm.js